.button {
  display: inline-flex;
  gap: var(--space-2);
  align-items: center;
  justify-content: center;
  min-height: var(--control-height);
  max-width: 100%;
  padding: var(--space-2) var(--space-4);
  font-size: var(--font-size-sm);
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
  overflow-wrap: anywhere;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: var(--radius-sm);
  transition:
    background var(--transition-fast),
    border-color var(--transition-fast);

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
}

.primary {
  color: var(--on-blue);
  background: var(--blue);

  &:hover:not(:disabled) {
    background: var(--blue-strong);
  }
}

.secondary {
  color: var(--text-primary);
  background: var(--surface-subtle);
  border-color: var(--border-soft);

  &:hover:not(:disabled) {
    background: var(--surface-hover);
    border-color: var(--border);
  }
}

.ghost {
  color: var(--blue);
  background: transparent;

  &:hover:not(:disabled) {
    background: var(--blue-soft);
  }
}

.danger {
  color: var(--on-error);
  background: var(--error);

  &:hover:not(:disabled) {
    background: var(--error-strong);
  }
}

.spinner {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  border: 2px solid currentcolor;
  border-right-color: transparent;
  border-radius: var(--radius-full);
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
